import React from 'react'
import { Avatar } from '@hub/avatar'
import { UserMediumIcon } from '@hub/icon'
import { IconButton } from '@hub/button'
import { AccountPaneProps } from './types'

export const AccountPaneSmall: React.FC<AccountPaneProps> = ({
  name,
  avatarSrc,
  isLoggedIn,
  displayAccountNav,
  sx,
}) =>
  isLoggedIn ? (
    <IconButton
      icon={<Avatar name={name} src={avatarSrc} />}
      aria-label="View your account details"
      colorScheme="white"
      size="small"
      sx={{
        ...sx,
        '&:hover': {
          color: 'quartz',
        },
        '&:active': {
          color: 'manatee',
        },
        '&:hover .chakra-avatar': {
          backgroundColor: 'quartz',
        },
        '&:active .chakra-avatar': {
          backgroundColor: 'manatee',
        },
      }}
      onClick={() => displayAccountNav(true)}
    />
  ) : (
    <IconButton
      icon={<UserMediumIcon boxSize="size-icon-md" />}
      aria-label="Log into Westfield Plus"
      colorScheme="white"
      size="small"
      sx={{
        ...sx,
        '&:hover': {
          color: 'quartz',
        },
        '&:active': {
          color: 'manatee',
        },
      }}
      onClick={() => displayAccountNav(true)}
    />
  )
